import "./NumbersSection.css"

export default function NumbersSection() {
  return (
    <section className="numbers-section">
      {/* Blue strip with text on left and form header on right */}
      <div className="blue-strip">
        <div className="container">
          <div className="blue-content">
            {/* Left side - Text content */}
            <div className="text-content">
              <h2>NEW PROJECT IN MIND?</h2>
              <h3>LET'S TALK!</h3>
              <div className="response-time">
                <span className="clock-icon">🕐</span>
                <span>RESPONSE IN LESS THAN 1 HOUR</span>
              </div>
            </div>

            {/* Right side - Form header and first fields only */}
            <div className="form-top">
              <div className="form-header">
                <h3>EXPLAIN YOUR PROJECT AND</h3>
                <h4>BOOK A MEETING TODAY.</h4>
              </div>

              <div className="form-row">
                <div className="form-field">
                  <label htmlFor="name">Name*</label>
                  <input type="text" id="name" />
                </div>
                <div className="form-field">
                  <label htmlFor="company">Company</label>
                  <input type="text" id="company" />
                </div>
              </div>

              <div className="form-row">
                <div className="form-field">
                  <label htmlFor="email">Email*</label>
                  <input type="email" id="email" />
                </div>
                <div className="form-field">
                  <label htmlFor="phone">Phone</label>
                  <input type="tel" id="phone" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Lower section with contact info on left and rest of form on right */}
      <div className="lower-section">
        <div className="container">
          <div className="lower-content">
            {/* Left side - Contact info */}
            <div className="contact-info">
              <h4>ALTERNATIVE CONTACTS (LANDLINE)</h4>

              <div className="contact-list">
                <div className="contact-item">
                  <span className="contact-icon email">✉</span>
                  <span>info@latticelabs.com</span>
                </div>

                <div className="contact-item">
                  <span className="contact-icon chat">💬</span>
                  <span>Chat</span>
                </div>

                <div className="contact-item">
                  <span className="contact-icon phone">📞</span>
                  <span>US: +1 (415) 842 2289</span>
                </div>

                <div className="contact-item">
                  <span className="contact-icon phone">📞</span>
                  <span>UK: +44 747 456 3437</span>
                </div>

                <div className="contact-item">
                  <span className="contact-icon phone">📞</span>
                  <span>PT: +351 21 386 0677</span>
                </div>
              </div>
            </div>

            {/* Right side - Rest of the form */}
            <div className="form-bottom">
              <form>
                <div className="form-field">
                  <label htmlFor="looking-for">I am looking for*</label>
                  <select id="looking-for">
                    <option value="">Please Select</option>
                    <option value="web-development">Web Development</option>
                    <option value="mobile-app">Mobile App</option>
                    <option value="consulting">Consulting</option>
                    <option value="other">Other</option>
                  </select>
                </div>

                <div className="form-field">
                  <label htmlFor="message">Message*</label>
                  <textarea id="message" rows="4"></textarea>
                </div>

                <div className="form-field">
                  <label htmlFor="hear-about">How did you hear about us?</label>
                  <select id="hear-about">
                    <option value="">Please Select</option>
                    <option value="google">Google</option>
                    <option value="social-media">Social Media</option>
                    <option value="referral">Referral</option>
                    <option value="other">Other</option>
                  </select>
                </div>

                <div className="form-field">
                  <label>FILE UPLOAD (OPTIONAL)</label>
                  <div className="file-upload">
                    <button type="button" className="file-button">
                      CHOOSE FILE
                    </button>
                    <span className="file-text">No file chosen</span>
                  </div>
                </div>

                <div className="consent-field">
                  <input type="checkbox" id="consent" />
                  <label htmlFor="consent">I allow Lattice Labs to store and process my personal data*</label>
                </div>

                <button type="submit" className="submit-button">
                  SUBMIT
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
